<!-- eslint-disable -->
<template>
  <div v-show="C_isVisible" class="image-button-container">
    <a 
      @mousedown="eventMouseDown(P_buttonId, P_makeSingleEvent)"
      @mouseup="eventMouseRelease(P_buttonId, P_makeSingleEvent)"
      @click="eventMouseClick(P_buttonId, P_makeSingleEvent)"
      class="image-button image-button-close"
      :class="{active: C_isActiveState}"
    ></a>
  </div>
</template>

<script>
/* eslint-disable */
import { bi10GridComponent } from "../../../watchdog_includes/base_i10_UI_mixins"

export default {
  props: ["P_buttonId", 'P_makeSingleEvent'],
  data () {
    return {}
  },
  mixins: [bi10GridComponent]
}
</script>

<style lang="less" scoped>
.image-button-container {
  width: 100%;
  height: 100%;
  color: var(--font-color1);
  font-weight: 500;
  .image-button {
    display: block;
    height: 100%;
    width: 100%; 
    background-position: center;
    background-repeat: no-repeat;
    background-size: 80%, 85%;
    &.image-button-close {
      background-image: url(/dynamic/images/b1/NU_GUI/close.png), url(/dynamic/images/b1/NU_GUI/red.png);
      &:active {
        background-image: url(/dynamic/images/b1/NU_GUI/close.png), url(/dynamic/images/b1/NU_GUI/blue.png);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Grid/crestron/GCloseButton.vue